import { FlaskConical } from "lucide-react";

// 2026-10-22 — PunchOut Sandbox (punchoutsandbox.com): a free cXML test
// catalog each company signs up for and enters in Settings > Punchout.
// Production supplier access is still being arranged, so wherever the
// sandbox shows up we say plainly that it is for testing only.
export const SANDBOX_HOST = "punchoutsandbox.com";

export const SANDBOX_PRESET = {
  name: "PunchOut Sandbox",
  punchout_url: `https://${SANDBOX_HOST}/punchout/setup`,
  order_request_url: `https://${SANDBOX_HOST}/order`,
  deployment_mode: "test",
};

export const isSandboxSupplier = (s) => (s?.punchout_url || "").toLowerCase().includes(SANDBOX_HOST);

export default function PunchoutSandboxNotice({ className = "" }) {
  return (
    <div className={`flex items-start gap-2 text-[12px] text-amber-800 bg-amber-50 border border-amber-100 rounded-lg px-3 py-2 ${className}`} data-testid="punchout-sandbox-notice">
      <FlaskConical size={13} className="mt-0.5 shrink-0" />
      <span>This is just a <b>sandbox punch-out catalog</b> for testing — orders placed here are not real. Production access is underway.</span>
    </div>
  );
}
